var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer center-align"},[_vm._v(" Deploy10 © 2025 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }